export default "__VITE_ASSET__DZApqJYU__"